<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<br/><p style="text-indent:0em;">“Every day you have a choice – be part of the problem or part of the solution.”</p>
<br/><p style="text-indent:0em;">Francis fox was born in 1973 and was raised in ‘the dodgy end’ of South London.</p>
<br/><p style="text-indent:0em;">Growing up he was highly motivated to improve his life experiences, and these early lessons forged his career as a management consultant and business turnaround expert.</p>
<br/><p style="text-indent:0em;">He has lived and worked around the world, stationed in Singapore, Thailand, Vietnam, Japan and Italy amongst others.</p>
<br/><p style="text-indent:0em;">A keen cyclist and with a strong penchant for Asian cuisine, he now shares his time with his family between Australia, Japan and the family home in Thailand along with five rescue cats (and counting).</p>
<br/><p style="text-indent:0em;">An Italian speaker and a student of Japanese currently, he is always looking to learn about new cultures and customs and this vibe has passed down to his children.</p>
<br/><p style="text-indent:0em;">Gas Meter Knees is his first book and it’s a rollercoaster ride through his formative years in 1980’s London that will make you laugh, cry and lots in between ‘sometimes you’re the pigeon – sometimes you’re the statue’.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?3e93c0c5